import React, { useState, useEffect } from "react";
import classes from './Payment.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import svg from "../../Assets/SVG.jpg";
import { Eye, Printer, Trash } from "lucide-react";

import filter from "../../Assets/SVG (1).png";
import exports from "../../Assets/file-export.png";
import invoice from "../../Assets/invoice-04.png";
import vector from "../../Assets/Vector.svg";
import date from "../../Assets/SVG (2).png";
import exported from "../../Assets/SVG (4).png";
import Footer from "../../Components/Footer/Footer";
import CashReciept from "./CashReciept/CashReciept";
import api from "../../Components/API/Api";
import PayeReceipt from "./CashReciept/PayeReceipt";
// use central `api` so interceptor attaches company_id/store_id

const PayePayment = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [payments, setPayments] = useState([]);
    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openCashReciept, setOpenCashReciept] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [agencies, setAgencies] = useState([]);


    const [baseCurrencyCode, setBaseCurrencyCode] = useState("NGN");

    useEffect(() => {
        const getBaseCurrencyCode = async () => {
            try {
                const companyRes = await api.get("/v1/companies/get-info");
                const companyData = Array.isArray(companyRes?.data?.data)
                    ? companyRes.data.data[0]
                    : companyRes?.data?.data;

                const currencyId = companyData?.currency_base; 

             
                const currenciesRes = await api.get(`/v1/fetch-all-currencies`);

                if (currenciesRes.data?.data && Array.isArray(currenciesRes.data.data)) {
                  
                    const baseCurrency = currenciesRes.data.data.find(
                        currency => String(currency.id) === String(currencyId)
                    );

                    if (baseCurrency && baseCurrency.code) {
                        setBaseCurrencyCode(baseCurrency.code);
                    } else {
                        setBaseCurrencyCode("NGN"); 
                    }
                }

            } catch (err) {
                console.error("Failed to fetch base currency", err);
                setBaseCurrencyCode("NGN"); // Fallback
            }
        };

        getBaseCurrencyCode();
    }, []);

    useEffect(() => {
        const fetchAgencies = async () => {
            try {
                const res = await api.get("/v1/taxagency");
                const list = Array.isArray(res?.data?.data) ? res.data.data : [];
                setAgencies(list);
            } catch (err) {
                console.error("Failed to fetch agencies", err);
                setAgencies([]);
            }
        };
        fetchAgencies();
    }, []);

    // Debounce search term
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearchTerm(searchTerm), 500);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    useEffect(() => {
        const fetchPayments = async () => {
            try {
                const authToken = localStorage.getItem("authToken");
                const companyId = localStorage.getItem("company_id");
                const response = await api.get('/v1/payee_payment?company_id=' + companyId + (debouncedSearchTerm ? '&search=' + encodeURIComponent(debouncedSearchTerm) : ''), {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                // ✅ Corrected data path
                const result = Array.isArray(response.data.data?.data)
                    ? response.data.data.data
                    : [];

                console.log("Fetched payments:", result);
                setPayments(result);
            } catch (error) {
                console.error("Error fetching payments:", error);
                setPayments([]);
            } finally {
                // ✅ Ensure loading stops even if error occurs
                setLoading(false);
            }
        };

        fetchPayments();
    }, [debouncedSearchTerm]);



    const allSelected = selectedRows.length === payments.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(payments.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((i) => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const getPaymentTo = (row) => {
        if (row.particular) return row.particular;
        if (row.customer) return row.customer.name;
        if (row.supplier) return row.supplier.name;
        return "-";
    };

    // NEW: navigate to the payment receipt route and pass payment via router state
    const handleOpenReceipt = (payment) => {
        // pass the entire payment object; the PaymentReceipt component can read it from location.state.payment
        navigate('/payment-voucher', { state: { payment } });
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Tax Remittances</h2>
                    <h1 className={classes.Titles}>
                        View all accounting transactions and account balances in chronological order.
                    </h1>
                </header>

                {/* === Metrics Cards === */}
                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        {/* <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total debits</p>
                                <p className={classes.kdptg1}>
                                    {selectMetrics?.total_debits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Credits</p>
                                <p className={classes.kdptg2}>
                                    {selectMetrics?.total_credits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Trial balance</p>
                                <p className={classes.kdptg3}>
                                    {selectMetrics?.trial_balance?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Balanced</p>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Entries</p>
                                <p className={classes.kdptg4}>
                                    {selectMetrics?.total_entries?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* === Header Actions === */}
                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={svg} alt="svg" className={classes.searchIcon} />
                            <select 
                                className={classes.searchBar} 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            >
                                <option value="">All Agencies</option>
                                {agencies.map((agency) => (
                                    <option key={agency.id} value={agency.agency_name || agency.name}>
                                        {agency.agency_name || agency.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All accounts</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div> */}

                        <div className={classes.inputWrapper}>
                            <img src={date} alt="date" className={classes.dateicon} />
                            <input type="text" className={classes.thirdBar} placeholder="Date Range" />
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={filter} alt="Filter" className={classes.filterIcon} />
                            <input type="text" className={classes.secondBar} placeholder="Filter" />
                        </div>
                    </div>

                    <div className={classes.inputWrapper}>
                        <button className={classes.btnss} onClick={() => setOpenCashReciept(true)}>
                            <img src={exported} alt="added" className={classes.invoiceIcon} />
                            New Payment
                        </button>
                    </div>
                </div>

                {/* === Payments Table === */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>S/N</th>
                                <th>Date</th>
                                <th>Agency</th>
                                <th>Month</th>
                                <th>Description</th>
                                <th>Currency</th>
                                <th>Amount</th>
                                {/* <th>{baseCurrencyCode} Amount</th> */}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                // ✅ Skeleton loader — 7 rows, 7 columns
                                Array.from({ length: 9 }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {[...Array(9)].map((_, colIndex) => (
                                            <td key={colIndex}>
                                                <div className={classes.skeletonBox}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : Array.isArray(payments) && payments.length > 0 ? (
                                payments.map((payment, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{payment.transaction_date}</td>
                                        <td>{payment.agency?.agency_name || "—"}</td>

                                        <td>{payment.month || "—"}</td>
                                        <td>{payment.description || "—"}</td>
                                        <td>{payment.currency?.currency || "—"}</td>
                                        <td style = {{textAlign:"right"}}>
                                            {parseFloat(payment.total_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                        {/* <td style = {{textAlign:"right"}}>
                                            {parseFloat(payment.total_converted_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td> */}
                                        <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                             <span
                                                onClick={() => handleOpenReceipt(payment)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleOpenReceipt(payment); }}
                                                aria-label={`Open receipt ${payment.invoice_number || payment.receipt_number || payment.uuid}`}
                                            ><Eye size={16} style={{ margin: "0 8px", color: "rgb(22,163,74)", cursor: "pointer" }} />
                                            </span>
                                            {/* make printer clickable to view full receipt */}
                                           
                                                <Printer size={16} style={{ margin: "0 8px", color: "rgb(37, 99, 235)", cursor: "pointer" }}/>
                                           
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        No payment records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                {/* === Pagination Footer === */}
                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td className={classes.frston}>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.twono}>2</td>
                            <td className={classes.lastno}>Last</td>
                        </tr>
                    </tfoot>
                </table>

                <div className={classes.lasone}>
                    <div className={classes.paginationDisplay}>Displaying 1 - 41 of 41</div>
                </div>
            </div>

            <PayeReceipt isOpen={openCashReciept} onClose={() => setOpenCashReciept(false)} />
            <Footer />
        </div>
    );
};

export default PayePayment;